import { makeAutoObservable } from 'mobx'

/** Tracks whether a newer frontend has been deployed and whether reloading onto it is safe right now. */
class NewVersionStore {
   isAvailable = false
   isDismissed = false
   private liveRecordingIds = new Set<string>()

   constructor() {
      makeAutoObservable(this, {}, { autoBind: true })
   }

   /** True while an in-person recording would lose its audio backup on reload. */
   get isRecordingLive() {
      return this.liveRecordingIds.size > 0
   }

   get isBannerVisible() {
      return this.isAvailable && !this.isDismissed
   }

   /** Shows the new-version banner unless the user has already dismissed it. */
   announce() {
      this.isAvailable = true
   }

   /** Hides the banner for the rest of this page load. */
   dismiss() {
      this.isDismissed = true
   }

   /**
    * Records whether a recording is at a stage where a reload would destroy it.
    * @param recordingId Identifies the recording, so several can be tracked at once.
    * @param isLive Whether that recording is recording, paused or uploading.
    */
   setRecordingLive(recordingId: string, isLive: boolean) {
      if (isLive) {
         this.liveRecordingIds.add(recordingId)
      } else {
         this.liveRecordingIds.delete(recordingId)
      }
   }

   /** Reloads onto the new version unless a recording would be lost. */
   reload() {
      if (this.isRecordingLive) return
      window.location.reload()
   }
}

export const newVersionStore = new NewVersionStore()
